(() => {
    let imageZoom = document.getElementsByClassName('zoom_container');
    var window_width = null;
    widthActual();

    for (let i = 0; i < imageZoom.length; i++) {
        let attribute = imageZoom[i];
        let image = attribute.getElementsByClassName('zoom-image')[0];
        let image_src = image.getAttribute('src');
        let style_attributes = `--url: url(${image_src}); --zoom-x: 0%; --zoom-y: 0%; --display: none; --opacity: 0`;

        attribute.setAttribute('style', style_attributes);
        

        if (window_width > 1200) {
            attribute.addEventListener('mousemove', (event) => {
                attribute.style.setProperty('--display', 'block');
                attribute.style.setProperty('--opacity', '1');
                attribute.style.setProperty('transition', 'all 1500ms linear');
                let pointer = {
                    x: (event.offsetX * 100) / attribute.offsetWidth,
                    y: (event.offsetY * 100) / attribute.offsetHeight
                }
                attribute.style.setProperty('--zoom-x', pointer.x + '%');
                attribute.style.setProperty('--zoom-y', pointer.y + '%');
            })
    
            attribute.addEventListener('mouseout', () => {
                attribute.style.setProperty('--display', 'none');
                attribute.style.setProperty('--opacity', '0');
                attribute.style.setProperty('transition', 'all 1500ms linear');
            })
        }
    };

    function widthActual() {
        window_width = window.innerWidth;
    }

    document.addEventListener("DOMContentLoaded", (ev) => {
        widthActual();
    });

    window.addEventListener("resize", (event) => {
        widthActual();
    });
})()